import { render, staticRenderFns } from "./EditGroupModal.vue?vue&type=template&id=a349b868&scoped=true&"
import script from "./EditGroupModal.vue?vue&type=script&lang=js&"
export * from "./EditGroupModal.vue?vue&type=script&lang=js&"
import style0 from "./EditGroupModal.vue?vue&type=style&index=0&id=a349b868&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a349b868",
  null
  
)

export default component.exports